"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopBar = TopBar;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _PrimaryLayout = require("b2b-components/theme/components/PrimaryLayout");
var _getComponentDataAttributes = require("b2b-components/utils/getComponentDataAttributes");
var _classnames = _interopRequireDefault(require("classnames"));
var _TopBarDropdown = require("./TopBarDropdown");
var _TopBarLanguages = require("./TopBarLanguages");
require("./TopBar.scss");
function TopBar(_ref) {
  let {
    activeLanguage,
    languages,
    onLanguageChange,
    onLinkClick,
    className,
    linksGroups,
    isDropdown,
    linksDataAttributes,
    langDataAttributes,
    dropdownDataAttributes
  } = _ref;
  const rootClassName = (0, _classnames.default)('cds-TopBar', className);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: rootClassName
  }, (0, _getComponentDataAttributes.getComponentDataAttributes)(linksDataAttributes)), /*#__PURE__*/_react.default.createElement(_PrimaryLayout.PrimaryLayout, {
    className: "cds-TopBar-Content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-Row cds-TopBar-Sections"
  }, /*#__PURE__*/_react.default.createElement(_TopBarDropdown.TopBarDropdown, {
    linksGroups: linksGroups,
    onLinkClick: onLinkClick
  }), /*#__PURE__*/_react.default.createElement(_TopBarLanguages.TopBarLanguages, {
    activeLanguage: activeLanguage,
    languages: languages,
    onLanguageChange: onLanguageChange,
    isDropdown: isDropdown,
    dataAttributes: langDataAttributes,
    dropdownDataAttributes: dropdownDataAttributes
  }))));
}
//# sourceMappingURL=TopBar.js.map